import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BlogSection from "../components/home/BlogSection";
import HeroSection from "../components/home/HeroSection";
import LabSection from "../components/home/LabSection";
import NameIntro from "../components/home/NameIntro";
import TimelineSection from "../components/home/TimelineSection";
import { useLanguage } from "../LanguageContext";

export default function HomePage() {
	const { lang } = useLanguage();
	const location = useLocation();

	useEffect(() => {
		const id = location.hash.replace(/^#/, "");
		if (!id) return;

		const frame = window.requestAnimationFrame(() => {
			const node = document.getElementById(id);
			if (!node) return;
			if (id === "contact") {
				const top = node.getBoundingClientRect().top + window.scrollY;
				window.scrollTo({ top, behavior: "smooth" });
				return;
			}
			node.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		});
		return () => window.cancelAnimationFrame(frame);
	}, [location.hash]);

	return (
		<>
			<NameIntro key={lang} />
			<div className="page-pad home-after-intro">
				<HeroSection />
				<TimelineSection />
				<BlogSection />
				<LabSection />
			</div>
		</>
	);
}
